(() => {
  if (window.bcwPopupCtaWatcher) return;

  const selector = '[data-kl-scroll-locking-modal], dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active, cart-drawer[open]';
  const candidates = new Set();
  let frame = 0;
  let fadeTimer = 0;
  let blocked = false;

  function visible(element) {
    if (!element.isConnected || !element.matches(selector)) return false;
    if (element.hasAttribute('data-kl-scroll-locking-modal') && element.getAttribute('data-kl-scroll-locking-modal') !== 'true') return false;
    if (element.tagName === 'DIALOG' && !element.hasAttribute('open')) return false;
    if (!element.getClientRects().length) return false;
    for (let node = element; node && node.nodeType === 1; node = node.parentElement) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  }

  function discover(root) {
    if (root.nodeType !== 1) return false;
    let found = false;
    if (root.matches(selector)) {
      candidates.add(root);
      found = true;
    }
    root.querySelectorAll(selector).forEach((element) => {
      candidates.add(element);
      found = true;
    });
    return found;
  }

  function sync() {
    frame = 0;
    let next = false;
    candidates.forEach((element) => {
      if (!element.isConnected || !element.matches(selector)) {
        element.classList.remove('bcw-course-modal', 'bcw-discount-modal', 'bcw-discount-mobile');
        candidates.delete(element);
        return;
      }
      const course = element.querySelector('[data-testid="klaviyo-form-Vh5QvC"]');
      const courseRoot = course && (course.closest('[data-kl-scroll-locking-modal="true"]') || course.closest('dialog[open], [role="dialog"][aria-modal="true"]'));
      const isCourseModal = courseRoot === element && element.tagName !== 'CART-DRAWER';
      if (element.classList.contains('bcw-course-modal') !== isCourseModal) element.classList.toggle('bcw-course-modal', isCourseModal);
      if (course && isCourseModal && !course.classList.contains('bcw-course-modal-form')) course.classList.add('bcw-course-modal-form');
      const discount = element.querySelector('[data-testid="klaviyo-form-VnG4VR"], [data-testid="klaviyo-form-R9Kvd2"]');
      const discountRoot = discount && (discount.closest('[data-kl-scroll-locking-modal="true"]') || discount.closest('dialog[open], [role="dialog"][aria-modal="true"]'));
      const isDiscountModal = discountRoot === element && element.tagName !== 'CART-DRAWER';
      const isMobileDiscount = isDiscountModal && discount.getAttribute('data-testid') === 'klaviyo-form-R9Kvd2';
      if (element.classList.contains('bcw-discount-modal') !== isDiscountModal) element.classList.toggle('bcw-discount-modal', isDiscountModal);
      if (element.classList.contains('bcw-discount-mobile') !== isMobileDiscount) element.classList.toggle('bcw-discount-mobile', isMobileDiscount);
      if (discount && isDiscountModal && !discount.classList.contains('bcw-discount-modal-form')) discount.classList.add('bcw-discount-modal-form');
      next = visible(element) || next;
    });
    if (next !== blocked) {
      blocked = next;
      document.body.classList.toggle('bcw-blocking-overlay-open', next);
      document.dispatchEvent(new CustomEvent('bcw:overlay-change', { detail: { open: next } }));
    }
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function scheduleVisibility() {
    schedule();
    window.clearTimeout(fadeTimer);
    fadeTimer = window.setTimeout(schedule, 180);
  }

  function relatesToCandidate(node) {
    for (const element of candidates) {
      if (node === element || node.contains(element) || element.contains(node)) return true;
    }
    return false;
  }

  function init() {
    discover(document.body);
    const observer = new MutationObserver((records) => {
      let changed = false;
      records.forEach((record) => {
        const target = record.target;
        if (record.type === 'childList') {
          record.addedNodes.forEach((node) => { changed = discover(node) || changed; });
          if (record.removedNodes.length || relatesToCandidate(target)) changed = true;
          return;
        }
        if (record.attributeName === 'class' && target === document.body) {
          const stripOwnClass = (value) => (value || '').replace(/\bbcw-(?:blocking-overlay-open|overlay-watcher-ready)\b/g, '').trim();
          if (stripOwnClass(record.oldValue) === stripOwnClass(target.className)) return;
        }
        if (target.matches(selector)) {
          candidates.add(target);
          changed = true;
        } else if (relatesToCandidate(target)) {
          changed = true;
        }
      });
      if (changed) scheduleVisibility();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden', 'aria-modal', 'role', 'data-kl-scroll-locking-modal']
    });
    ['transitionend', 'animationend', 'toggle', 'close'].forEach((name) => document.addEventListener(name, (event) => {
      if (event.target.nodeType === 1 && relatesToCandidate(event.target)) schedule();
    }, true));
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', scheduleVisibility);
    document.addEventListener('visibilitychange', scheduleVisibility);
    window.bcwPopupCtaWatcher = { refresh: scheduleVisibility };
    sync();
    document.body.classList.add('bcw-overlay-watcher-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
